import { Button, Typography, Snackbar, Alert, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, TextField } from "@mui/material";
import BreadCrumb from "../../Components/BreadCrumbs";
import ErrorIcon from "@mui/icons-material/Error";
import CaseDetailsHeadedCard from "../../Components/CaseDetailsHeaderCard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CaseDetailsContentCard from "../../Components/CaseDetailsContentCard";
import { useNavigate, useParams } from "react-router-dom";
import {
  _getCase,
  httpGet,
  httpPost,
  httpDelete,
  httpPatch,
  getCourseCategory,
  getAllCourses,
} from "../../Services/api-services";
import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import SideNav, { MenuIcon } from "react-simple-sidenav";
import CONSTANTS from "../../constant.json";
import CasesSidenav from "../../Components/CasesSidenav";
import PaymentScheduleDialog from "../../Popups/PaymentScheduleDialog";
import AddIcon from "@mui/icons-material/Add";
import { UserAuthState } from "../../Services/RecoilService";
import { useRecoilState } from "recoil";
import AddCourse from "./AddCourse";
import { get, patch, post } from "../../Services/services";
import CallIcon from "@mui/icons-material/Call";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import SchoolIcon from "@mui/icons-material/School";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import moment from "moment";
import { Box } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function CaseDetails() {
  const [caseData, setCasesData] = useState();
  const [fetchCase, setFetchCase] = useState(null);
  const [currency, setCurrency] = useState('');
  const [currentCourse, setCurrentCourse] = useState(0);
  const [openCases, setOpenCases] = useState([]);
  const [caseDialog, setCaseDialog] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [discountRequest, setDiscountRequest] = useState(null);
  const [showNav, setShowNav] = useState(false);
  const [subscribeCourseId, setSubscribeCourseId] = useState("");
  const [PaymentDialog, setPaymentDialog] = useState(false);
  const [showAddButton, setShowAddButton] = useState(false);
  const [authState] = useRecoilState(UserAuthState);
  const [edit, setEdit] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [editedData, setEditedData] = useState(null);
  const [countyData, CountyData] = useState([]);
  const [stateData, setStateData] = useState([]);
  // Removed cityData and schoolData state variables
  const [boardData, setBoardData] = useState([]);
  const [careerOptionData, setCareerOptionData] = useState([]);
  const [sourceData, setSourceData] = useState([]);
  const [occupationData, setOccupationData] = useState([]);
  const [courseData, setCourseData] = useState([]);
  const [studentTags, setStudentTags] = useState([]);
  const [notFound, setNotFound] = useState();
  const [nextExpectedCourse, setNextExpectedCourse] = useState([])
  const [snackBarOptions, setSnackBarOptions] = useState({
    message: "",
    show: false,
    severity: "success",
    duration: 5000,
  });

  // New states for date selection dialog
  const [dateDialogOpen, setDateDialogOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [currentStatusField, setCurrentStatusField] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);

  const [activeStatusField, setActiveStatusField] = useState(null);
  const [tempSelectedDate, setTempSelectedDate] = useState(new Date());

  const [courseFormData, setCourseFormData] = useState({
    batchModeId: "",
    batchId: "",
    courseId: "",
    subjectIds: [],
    subjectNames: [],
    addOnsId: [],
    addOnsNames: [],
    note: "",
    currency: "",
    courseAmount: 0,
    bundleDiscount: 0,
    addonAmount: 0,
    studentDiscount: 0,
    referenceId: "",
  });

  const { state } = useLocation();
  const caseId = state?.id;
  const origin = state?.origin;


  let { dialog, _courseId } = state ? state : { dialog: false, _courseId: null };
  const [opnDialog, setOpnDialog] = useState(true);

  const navigate = useNavigate();

  const loadReferenceData = async (countryId) => {
    try {
      const res = await get(`states?filter={"where":{"countryId":"${countryId}","status":true}}`)
      // Removed school data loading
      const resss = await get(`boards?filter={"where":{"countrycountryId":"${countryId}","status":true}}`)
      const rest = await getCourseCategory()

      if (res.statusCode === 200 && resss.statusCode === 200 && rest.statusCode === 200) {
        setStateData(res.data);
        // Removed setSchoolData
        setBoardData(resss.data);
        setCourseData(rest);
      }

      const fieldTypesRes = await httpPost(`${CONSTANTS.baseUrl}/fieldTypes/getAllFieldTypeWithField`, { status: true });

      if (fieldTypesRes.statusCode === 200) {
        fieldTypesRes.data?.forEach((item) => {
          if (item.title === "career options") {
            setCareerOptionData(item?.field);
          } else if (item.title === "source") {
            setSourceData(item?.field);
          } else if (item.title === "parent occupation") {
            setOccupationData(item?.field);
          }
        });
      }
    } catch (error) {
      console.error("Error loading reference data:", error);
    }
  };

  // Removed getCity function as it's no longer needed

  useEffect(() => {
    const modules = authState?.userData?.assignModules?.assignModule;
    const openCasesArr = modules?.find((m) => m?.name === "Open cases");
    setOpenCases(openCasesArr);
    fetchData();
  }, [showNav]);

  async function fetchData() {
    try {
      let body = {
        caseId: caseId,
      };
      const response = await _getCase(body);

      blockAddButton(response);
      setFetchCase(response);

      if (response?.case?.countryId) {
        loadReferenceData(response?.data?.cases[0]?.countryId);
      }
      console.log(response.case.stateId?.id, "IDDDD");

      // Removed getCity call

      if (opnDialog && response?.subscribedCourses?.length > 0) {
        let index = response?.subscribedCourses?.findIndex(s => s?.courses?._id === _courseId);
        if (index >= 0) {
          const url = `${CONSTANTS.baseUrl}/countries/${response?.subscribedCourses[index].courses?.currency}`;
          const currResponse = await httpGet(url);
          setCurrency(currResponse);
          openSideNav(response?.subscribedCourses[index]['_id'], index);
          setTabIndex(1);
        }
      }
    } catch (error) {
      console.error("Error fetching case data:", error);
      setSnackBarOptions({
        message: "Error fetching case data",
        show: true,
        severity: "error",
        duration: 5000,
      });
    }
  }

  const handleEditMode = () => {
    setIsEditing(true);
    setEditedData({
      case: { ...fetchCase?.case }
    });
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditedData(null);
  };

  const handleSaveEdit = async (updatedData) => {
    try {

      const payload = {
        ...updatedData.case,
      };
      console.log([payload, "pay"]);

      // Modified to handle city and school as strings
      if (payload.state?.id) payload.stateId = payload.state.id;
      if (payload.board?.id) payload.boardId = payload.board.id;
      if (payload.careerOption?._id) payload.careerOptionId = payload.careerOption._id;
      if (payload.source?._id) payload.sourceId = payload.source._id;
      // if (payload.nextCourse?._id) payload.futureCourse = payload.nextCourse._id;
      if (payload.fatherOccupation?._id) payload.fatherOccupationId = payload.fatherOccupation._id;
      if (payload.motherOccupation?._id) payload.motherOccupationId = payload.motherOccupation._id;
      if (payload.guardianOccupation?._id) payload.guardianOccupationId = payload.guardianOccupation._id;
      if (payload.studentTags?.id) payload.studentTags = payload.studentTags.id;
      if (payload.futureCourses?.id) payload.futureCourses = payload.futureCourses.id;
      // City and school will be stored as strings, no need for ID conversion
      // payload.city and payload.school remain as strings

      // Removed city and school from deletion list
      delete payload.state;
      delete payload.board;
      delete payload.careerOption;
      delete payload.source;
      // delete payload.nextCourse;
      delete payload.fatherOccupation;
      delete payload.motherOccupation;
      delete payload.guardianOccupation;
      delete payload.futureCourses;

      const res = await patch(`cases/${caseId}`, payload)

      if (res.statusCode === 200) {
        setSnackBarOptions({
          message: "Case updated successfully",
          show: true,
          severity: "success",
          duration: 3000,
        });

        await fetchData();
        setIsEditing(false);

      }
    } catch (error) {
      console.error("Error saving data:", error);
      setSnackBarOptions({
        message: error.message || "Error updating case",
        show: true,
        severity: "error",
        duration: 5000,
      });
    }
  };

  const handleFieldChange = (field, value) => {
    setEditedData(prev => ({
      ...prev,
      case: {
        ...prev.case,
        [field]: value
      }
    }));

    // Removed getCity call for state change since city is now a text field
  };

  function blockAddButton(row) {
    let subscribe = row?.subscribedCourses;
    let checkPay = true;

    for (let i = 0; subscribe && i < subscribe.length; i++) {
      if (!subscribe[i]?.feePaid) {
        if (!subscribe[i]?.refunds) {
          checkPay = false;
        }
      }
    }
    setShowAddButton(checkPay);
  }

  function openSideNav(id, index) {
    setCurrentCourse(index);
    setSubscribeCourseId(id);
    fetchDiscountRequest(id);
    setShowNav(true);
  }

  async function fetchDiscountRequest(id) {
    const filter = `?filter={"where": {"subscribedCoursesId": "${id}"}}`;
    const url = `${CONSTANTS.baseUrl}/discountRequests${filter}`;
    const response = await httpGet(url);
    setDiscountRequest(response);
  }

  function closePaymentDialog() {
    setShowNav(false);
    setPaymentDialog(false);
  }

  async function onDownpaymentClick(index) {
    const url = `${CONSTANTS.baseUrl}/countries/${fetchCase?.subscribedCourses[index].courses?.currency}`;
    const response = await httpGet(url);
    setCurrency(response?.currencyName);
    setTabIndex(index);
    setPaymentDialog(true);
  }

  function refreshCase() {
    fetchData();
  }

  function openCase() {
    if (origin === 'reports') {
      navigate("/home/reports");
    } else if (origin === 'old_cases') {
      navigate("/home/old_cases");
    } else if (origin === 'enrollments') {
      navigate("/home/enrollments");
    } else if (origin === 'approved_refunds') {
      navigate("/home/approved_refunds");
    } else {
      navigate("/home/open_cases");
    }
  }

  const handleEditForm = (data) => {
    let subjectNames = [];
    let subjectIds = [];
    let addOnsNames = [];
    let addOnsId = [];

    data?.subjects?.forEach((item) => {
      subjectNames.push(item?.name);
      subjectIds.push(item?._id);
    });

    data?.addOns?.forEach((item) => {
      addOnsNames.push(item?.name);
      addOnsId.push(item?._id);
    });

    setCourseFormData({
      batchModeId: data?.batchMode?._id,
      batchId: data?.batchId,
      courseId: data?.courseId,
      subjectIds: subjectIds,
      subjectNames: subjectNames,
      addOnsId: addOnsId,
      addOnsNames: addOnsNames,
      note: data?.note,
      currency: "",
      courseAmount: data?.courseAmount,
      bundleDiscount: data?.bundleDiscount,
      addonAmount: data?.addonAmount,
      studentDiscount: data?.studentDiscount,
      referenceId: data?.referenceId,
      studentTagsId: data?.studentTagsId,
    });

    setEdit(data?._id);
    setCaseDialog(true);
  };

  const handleCloseSnackbar = () => {
    setSnackBarOptions({
      ...snackBarOptions,
      show: false,
    });
  };

  const cases = [
    <Typography
      onClick={openCase}
      component={"div"}
      sx={{ fontSize: "20px" }}
      key="1"
    >
      {origin === 'reports' ? 'Reports' : origin === 'old_cases' ? 'Old Cases' : origin === 'enrollments' ? 'Enrollments' : origin === 'approved_refunds' ? 'Approved Refunds' : 'Open Cases'}
    </Typography>,
    <Typography component={"div"} sx={{ fontSize: "20px" }} key="2">
      Case Details
    </Typography>,
  ];

  // Open date selection dialog instead of immediately updating status
  const openDateSelectionDialog = (field) => {
    setCurrentStatusField(field);
    setSelectedDate(moment());
    setDateDialogOpen(true);
  };
  const handleDirectDateSelection = (field) => {
    if (activeStatusField === field) {
      setActiveStatusField(null);
    } else {
      setActiveStatusField(field);
      setTempSelectedDate(new Date());
    }
  };

  const handleStatusUpdate = async (field, date) => {
    try {
      const updateData = {
        [field]: true,
        [`${field}Date`]: date.toISOString()
      };

      const response = await httpPatch(
        `${CONSTANTS.baseUrl}/cases/${caseId}`,
        updateData
      );

      if (response.statusCode === 200) {
        setSnackBarOptions({
          message: `${field} marked as complete`,
          show: true,
          severity: "success",
          duration: 3000,
        });
        fetchData();
        setActiveStatusField(null);
      }
    } catch (error) {
      setSnackBarOptions({
        message: error.message || "Error updating status",
        show: true,
        severity: "error",
        duration: 5000,
      });
    }
  };

  const handleDateSelect = async (field, date) => {
    setTempSelectedDate(date);
    await handleStatusUpdate(field, date);
    fetchData()
    // getCaseData()
  };

  const getCaseData = async () => {

    const res = await post("cases/getCaseDetails", { caseId: caseId });
    const rest = await getAllCourses()
    setNextExpectedCourse(rest)

    if (res?.statusCode === 200) {
      if (res?.data?.statusCode === 200) {
        setCasesData(res?.data?.cases[0]);
        getState(res?.data?.cases[0]?.countryId)
      } else if (res?.data?.statusCode === 402) {
        setNotFound(res?.data)
      }
    }
    //  = Object.keys(statesData[res?.data?.cases[0]?.country?.name]);
  }

  const getState = async (id) => {
    const res = await get(`states?filter={"where":{"countryId":"${id}","status":true}}`)
    // Removed school data loading
    const resss = await get(`boards?filter={"where":{"countryId":"${id}","status":true}}`)
    const rest = await post(`courses/getCourseForRegistrationForm`, { id: id })
    const courseCategory = await getCourseCategory();

    if (res.statusCode === 200 && resss.statusCode === 200 && rest.statusCode === 200) {
      setStateData(res.data);
      // Removed setSchoolData
      setBoardData(resss.data);
      setCourseData(courseCategory);
    }
  }

  const getDesignation = async () => {
    const res = await post("fieldTypes/getAllFieldTypeWithField", { status: true });

    if (res.statusCode === 200) {
      res.data?.map((item) => {
        if (item.title === "career options") {
          setCareerOptionData(item?.field);
        } else if (item.title === "parent occupation") {
          setOccupationData(item?.field)
        }
        else if (item.title === "Source of info about APT") {
          setSourceData(item?.field);
        }
        // else if (item.title === 'blood group') {
        //     setBloodGroup(item?.field)
        // } else if (item.title === 'previous class/course') {
        //     setPreviousClass(item?.field)
        // } else if (item.title === 'post/designation') {
        //     setDesignation(item?.field)
        // }
      }
      )

    }
  }

  const getStudenTags = async () => {
    const res = await post("tags/getAllTags", { status: true });
    if (res.statusCode === 200) {
      const activeTags = res.data?.data
        ?.filter(item => item.status === true);
      setStudentTags(activeTags);
    }
  };

  // useEffect(() => {
  //   refreshCase()
  // },[])

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    getCaseData()
    getDesignation()
    getStudenTags()
  }, [])

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div className="h-full w-full overflow-auto">
        <div className="p-4 flex items-center">
          <ArrowBackIcon
            onClick={openCase}
            sx={{
              color: "gray",
              fontSize: "18px",
              marginRight: "20px",
              cursor: "pointer",
            }}
          />
          <BreadCrumb openCase={openCase} data={cases} />
          {!fetchCase?.case?.isRegistered && <div>
            <span className='ml-20'><ErrorIcon sx={{ color: "red", fontSize: "15px" }} /></span>
            <span className='ml-2 text-sm text-gray-400'>Not registered...</span>
          </div>}
        </div>

        {fetchCase && (
          <div className="mx-5 mb-4 p-4 bg-white rounded-lg shadow">
            <Box className="gap-5 flex justify-between flex-wrap">
              {/* Welcome Call Status */}
              <Box className="flex gap-2 items-center">
                <CallIcon />
                <p>Have you completed Welcome call?</p>
                {fetchCase?.case?.welcomeCall ? (
                  <Box className="flex items-center gap-2">
                    <CheckCircleIcon sx={{ color: "#4CAF50" }} />
                    <p>{moment(fetchCase?.case?.welcomeCallDate).format("MM/DD/YYYY")}</p>
                  </Box>
                ) : (
                  <Box>
                    {activeStatusField === 'welcomeCall' ? (
                      <DatePicker
                        selected={tempSelectedDate}
                        onChange={(date) => handleDateSelect('welcomeCall', date)}
                        onSelect={(date) => handleDateSelect('welcomeCall', date)} // This triggers on calendar selection
                        dateFormat="MM/dd/yyyy"
                        customInput={
                          <TextField
                            size="small"
                            autoFocus
                            sx={{ width: '150px' }}
                            value={tempSelectedDate ? moment(tempSelectedDate).format("MM/DD/YYYY") : ""}
                          />
                        }
                        onClickOutside={() => setActiveStatusField(null)}
                        shouldCloseOnSelect={true} // Close calendar after selection
                      />
                    ) : (
                      <Button
                        disabled={!(openCases?.update || openCases?.write)}
                        onClick={() => handleDirectDateSelection('welcomeCall')}
                        color="error"
                        size="small"
                        variant="outlined"
                      >
                        Yes
                      </Button>
                    )}
                  </Box>
                )}
              </Box>

              {/* WhatsApp Group Status */}
              <Box className="flex gap-2 items-center">
                <WhatsAppIcon sx={{ color: "#64748B" }} />
                <p>Did student join WhatsApp group?</p>
                {fetchCase?.case?.whatsappGroup ? (
                  <Box className="flex items-center gap-2">
                    <CheckCircleIcon sx={{ color: "#4CAF50" }} />
                    <p>{moment(fetchCase?.case?.whatsappGroupDate).format("MM/DD/YYYY")}</p>
                  </Box>
                ) : (
                  <Box>
                    {activeStatusField === 'whatsappGroup' ? (
                      <DatePicker
                        selected={tempSelectedDate}
                        onChange={(date) => handleDateSelect('whatsappGroup', date)}
                        onSelect={(date) => handleDateSelect('whatsappGroup', date)}
                        dateFormat="MM/dd/yyyy"
                        customInput={
                          <TextField
                            size="small"
                            autoFocus
                            sx={{ width: '150px' }}
                            value={tempSelectedDate ? moment(tempSelectedDate).format("MM/DD/YYYY") : ""}
                          />
                        }
                        onClickOutside={() => setActiveStatusField(null)}
                        shouldCloseOnSelect={true}
                      />
                    ) : (
                      <Button
                        disabled={!(openCases?.update || openCases?.write)}
                        onClick={() => handleDirectDateSelection('whatsappGroup')}
                        color="error"
                        size="small"
                        variant="outlined"
                      >
                        Yes
                      </Button>
                    )}
                  </Box>
                )}
              </Box>

              {/* Academic Counseling Status */}
              <Box className="flex gap-2 items-center">
                <SchoolIcon />
                <p>Have you completed Academic counseling?</p>
                {fetchCase?.case?.academicCounseling ? (
                  <Box className="flex items-center gap-2">
                    <CheckCircleIcon sx={{ color: "#4CAF50" }} />
                    <p>{moment(fetchCase?.case?.academicCounselingDate).format("MM/DD/YYYY")}</p>
                  </Box>
                ) : (
                  <Box>
                    {activeStatusField === 'academicCounseling' ? (
                      <DatePicker
                        selected={tempSelectedDate}
                        onChange={(date) => handleDateSelect('academicCounseling', date)}
                        onSelect={(date) => handleDateSelect('academicCounseling', date)}
                        dateFormat="MM/dd/yyyy"
                        customInput={
                          <TextField
                            size="small"
                            autoFocus
                            sx={{ width: '150px' }}
                            value={tempSelectedDate ? moment(tempSelectedDate).format("MM/DD/YYYY") : ""}
                          />
                        }
                        onClickOutside={() => setActiveStatusField(null)}
                        shouldCloseOnSelect={true}
                      />
                    ) : (
                      <Button
                        disabled={!(openCases?.update || openCases?.write)}
                        onClick={() => handleDirectDateSelection('academicCounseling')}
                        color="error"
                        size="small"
                        variant="outlined"
                      >
                        Yes
                      </Button>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          </div>)}

        {fetchCase ? (
          <div className="mt-3 mb-16">
            <CaseDetailsHeadedCard
              openCases={openCases}
              fetchCase={fetchCase}
              isEditing={isEditing}
              editedData={editedData}
              onEditClick={handleEditMode}
              onCancelEdit={handleCancelEdit}
              onSaveEdit={handleSaveEdit}
              onFieldChange={handleFieldChange}
              stateData={stateData}
              // Removed cityData and schoolData props
              boardData={boardData}
              careerOptionData={careerOptionData}
              sourceData={sourceData}
              occupationData={occupationData}
              courseData={courseData}
              nextExpectedCourse={nextExpectedCourse}
              studentTags={studentTags}
            />
          </div>
        ) : null}

        {fetchCase?.subscribedCourses?.map((course, index) => {
          const isPaymentLocked = course?.paymentSchedule || course?.totalPaymentDone?.totalPaymentDone > 0

          return (
            <div className="mt-8" key={index}>
              <CaseDetailsContentCard
                openCases={openCases}
                handleEditForm={handleEditForm}
                onDownpaymentClick={() => onDownpaymentClick(index)}
                subscribedCourse={course}
                openSideNav={() => openSideNav(course._id, index)}
                fetchCase={fetchCase}
                isEditDisabled={isPaymentLocked}
                isDeleteDisabled={isPaymentLocked}
              />
            </div>
          )
        })}

        <SideNav
          className="z-10"
          style={{ zIndex: 1 }}
          openFromRight={true}
          showNav={showNav}
          onHideNav={() => { setOpnDialog(false); setShowNav(false) }}
          title={null}
          children={[
            <div key={0} className="cursor-default overflow-auto ">
              {fetchCase?.subscribedCourses?.[currentCourse] && (
                <CasesSidenav
                  openCases={openCases}
                  caseId={caseId}
                  refreshCase={refreshCase}
                  courseData={fetchCase.subscribedCourses[currentCourse]}
                  showNav={showNav}
                  fetchCase={fetchCase}
                />
              )}
            </div>
          ]}
          navStyle={{ maxWidth: "65%" }}
        />

        {PaymentDialog && (
          <PaymentScheduleDialog
            currency={currency}
            PaymentDialog={PaymentDialog}
            closePaymentDialog={closePaymentDialog}
            courseData={fetchCase?.subscribedCourses[currentCourse]}
            userData={authState?.userData}
            fetchCase={fetchCase}
            dialogTitle={"DOWN PAYMENT"}
            refreshCase={refreshCase}
          />
        )}

        <div style={{ display: !(openCases?.write || openCases?.update) || fetchCase?.case?.deleted ? "none" : "block" }}>
          <Button
            onClick={() => setCaseDialog(true)}
            variant="contained"
            sx={{
              borderRadius: "50px",
              height: "60px",
              width: "60px",
              position: "fixed",
              bottom: "40px",
              right: "40px",
            }}
          >
            <AddIcon sx={{ fontSize: "30px" }} />
          </Button>
        </div>

        <AddCourse
          fetchCase={fetchCase}
          edit={edit}
          setEdit={setEdit}
          fetchData={fetchData}
          caseId={caseId}
          setCourseFormData={setCourseFormData}
          courseFormData={courseFormData}
          open={caseDialog}
          setOpen={setCaseDialog}
        />

        <Snackbar
          open={snackBarOptions.show}
          autoHideDuration={snackBarOptions.duration}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseSnackbar}
            severity={snackBarOptions.severity}
            sx={{ width: '100%' }}
          >
            {snackBarOptions.message}
          </Alert>
        </Snackbar>
      </div>
    </LocalizationProvider>
  );
}

export default CaseDetails;